import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from '../core/core.module';
import { VendorModule } from '../core/vendor.module';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { SecurityModule } from '../security/security.module';
import { SlideshowModule } from 'ng-simple-slideshow';
import { QuillEditorModule } from 'ngx-quill-editor';
import { NgxMaskModule } from 'ngx-mask';
import { SecurityService } from '../security/security.service';
import { LoguedGuardService } from '../security/logued-guard.service';
import { TiposEnvioComponent } from './tiposEnvio.component';
import { TiposEnvioListComponent } from './tiposEnvio-list.component';
import { TiposEnvioAddEditComponent } from './tiposEnvio-add-edit.component';
import { TiposEnvioResolver } from './tiposEnvio.resolver';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    SlideshowModule,
    QuillEditorModule,
    NgxMaskModule,
  ],
  declarations: [
    TiposEnvioComponent,
    TiposEnvioListComponent,
    TiposEnvioAddEditComponent
  ],
  exports: [
    TiposEnvioComponent,
    TiposEnvioListComponent,
    TiposEnvioAddEditComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    TiposEnvioResolver
  ]
})
export class TiposEnvioModule { }



// WEBPACK FOOTER //
// ./src/app/tiposEnvio/tiposEnvio.module.ts